<template>
  <div class="m-grid m-grid--hor m-grid--root m-page">
    <AppHeader />

    <!-- begin::Body -->
    <div
      class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body"
    >
      <LeftMenu />

      <div
        v-if="canViewAndEditDataFeeds"
        class="m-grid__item m-grid__item--fluid m-wrapper"
      >
        <div class="m-content">
          <div class="row">
            <!-- Begin: Portlets -->

            <div class="col">
              <div class="m-portlet m-portlet--rounded m-portlet--head-sm">
                <div class="m-portlet__head">
                  <div class="m-portlet__head-caption">
                    <div class="m-portlet__head-title">
                      <h3 class="m-portlet__head-text">
                        {{
                          $t(
                            "Property.DataFeed.CountFeeds",
                            feedList.length || 0,
                            {
                              count:
                                typeof feedList !== "undefined"
                                  ? feedList.length
                                  : 0,
                            }
                          )
                        }}
                      </h3>
                    </div>
                  </div>

                  <div class="m-portlet__head-actions">
                    <a
                      class="btn ws-nowrap btn-brand m-btn m-btn--custom m-btn--icon btn-sm font-weight-light m--font-light add-action"
                      @click="createDataFeed"
                    ><span><i class="la la-plus" />
                      <span class="ws-nowrap">{{
                        $t("Property.DataFeed.CreateFeed")
                      }}</span></span></a>
                  </div>
                </div>
                <div class="m-portlet__body">
                  <div class="row">
                    <!-- Begin: Alert Message -->
                    <div class="col-xl-12">
                      <div
                        class="m-alert m-alert--icon m-alert--icon-solid m-alert--outline alert alert-danger alert-dismissible fade show"
                        role="alert"
                      >
                        <div class="m-alert__icon">
                          <i class="flaticon-exclamation-1" />
                          <span />
                        </div>
                        <div
                          class="m-alert__text"
                          v-html="$t('Property.DataFeed.infoMsg')"
                        />
                        <div class="m-alert__close">
                          <button
                            type="button"
                            class="close"
                            data-dismiss="alert"
                            aria-label="Close"
                          />
                        </div>
                      </div>
                    </div>
                    <!-- END: Alert Message -->
                  </div>
                  <div class="table_sticky-header">
                    <table
                      class="table m-table m-table--head-no-border table table-striped not-responsive"
                    >
                      <thead>
                        <tr class="">
                          <th
                            style="width: auto"
                            class="text-left"
                          >
                            {{ $t("Property.DataFeed.FeedName") }}
                          </th>
                          <th
                            style="width: auto"
                            class="text-right"
                          >
                            {{ $t("Property.table.actions") }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <!-- Begin: feeds tr's-->
                        <template v-if="feedList">
                          <tr
                            v-for="(feed, index) in feedList"
                            :key="feed[index]"
                          >
                            <td
                              class="align-middle"
                              :data-thead-name="
                                $t('Property.DataFeed.FeedName')
                              "
                            >
                              {{ feed.Name }}
                            </td>

                            <td class="text-right align-middle">
                              <a
                                class="btn m-btn--sm btn-primary btn-block-sm mb-1"
                                :href="getViewLink(feed.Identifier)"
                                target="_blank"
                              >{{ $t("common.View") }}</a>
                              <button
                                class="btn m-btn--sm btn-primary btn-block-sm mb-1"
                                @click="editDataFeed(feed.ID, feed.Name)"
                              >
                                {{ $t("common.Edit") }}
                              </button>
                              <button
                                class="btn m-btn--sm btn-primary btn-block-sm mb-1"
                                @click="
                                  copyTextToClipboard(xml_url + feed.Identifier)
                                "
                              >
                                {{ $t("common.CopyLink") }}
                              </button>
                              <button
                                class="btn m-btn--sm btn-danger btn-block-sm mb-1"
                                @click="deleteDataFeed(feed.ID, feed.Name)"
                              >
                                {{ $t("common.Delete") }}
                              </button>
                            </td>
                          </tr>
                        </template>
                        <template v-if="feedList.length === 0">
                          <tr>
                            <td
                              colspan="11"
                              class="text-center m--regular-font-size-lg3 py-5"
                            >
                              {{ $t("Property.table.NoRecordsFound") }}
                            </td>
                          </tr>
                        </template>
                        <!-- Begin: feeds tr's-->
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <!-- END: Portlets -->
          </div>
        </div>
      </div>
      <template v-if="!canViewAndEditDataFeeds && !loading">
        <NoPropertyServices />
      </template>

      <!-- Begin: MODAL -->
      <div
        id="addFeedModal"
        class="modal fade"
        tabindex="-1"
        role="dialog"
        aria-labelledby=""
        style="display: none"
        aria-hidden="true"
      >
        <div
          class="modal-dialog modal-lg"
          role="document"
        >
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">
                <span class="text-capitalize">
                  {{ $t("Property.DataFeed." + modal_mode) }} </span>{{ $t("Property.DataFeed.ModalTile") }}
              </h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              <form novalidate="novalidate">
                <div class="form-group">
                  <label
                    for="feed-name"
                    class="form-control-label"
                  >{{ $t("Property.DataFeed.Name") }}:
                    <small>(*) </small></label>
                  <input
                    id="feed-name"
                    v-model="formData.name"
                    name="Name"
                    type="text"
                    :placeholder="$t('Property.DataFeed.NamePlaceholder')"
                    class="form-control m-input m-input--solid"
                    required
                  >
                  <input
                    id="FeedID"
                    v-model="formData.feedID"
                    name="ID"
                    type="hidden"
                  >
                </div>
              </form>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                {{ $t("Property.DataFeed.Close") }}
              </button>
              <button
                type="button"
                class="btn btn-primary"
                @click="submitForm"
              >
                <span class="text-capitalize">{{
                  $t("Property.DataFeed." + modal_mode)
                }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- END: MODAL -->
    </div>
    <!-- end:: Body -->

    <!-- BEGIN: Footer -->
    <AppFooter />
    <!-- END: Footer -->
  </div>
</template>

<script>
import AppHeader from '../common/Header.vue';
import AppFooter from '../common/Footer.vue';
import LeftMenu from '../common/menus/LeftMenu.vue';
import NoPropertyServices from '../../dashboard/services/Property.vue';
import { getUser, getPropertyService, onBeforeOpenSwal } from '../../../functions.ts';
import { clientapi } from '../../../api-clients/client-api.js';

export default {
    components: {
        AppFooter,
        AppHeader,
        LeftMenu,
        NoPropertyServices,
    },
    beforeRouteLeave( to, from, next ) {
        $( '.modal' ).modal( 'hide' );
        next();
    },
    data() {
        return {
            xml_url: import.meta.env.TWC_XML_URL,
            loading: true,
            modal_mode: 'create', // create or edit
            limitMaxFeed: 20,
            formData: {
                Name: '',
                FeedID: '',
            },
            feedList: [],
            user: {},
            propertyService: { Status: 'NOT_ACTIVE' },
        };
    },
    computed: {
        canViewAndEditDataFeeds() {
            let allowedStatuses = [ 'ACTIVE', 'ACTIVE_FUTURE', 'ACTIVE_EXPIRED', 'ACTIVE_PENDING', 'ACTIVE_SUSPENDED' ];
            return allowedStatuses.includes( this.propertyService.Status );
        },
    },
    beforeUnmount() {
        $( '.modal' ).modal( 'hide' );
    },
    async mounted() {
        this.user = getUser();
        this.propertyService = await getPropertyService();
        this.loading = false;

        if ( this.canViewAndEditDataFeeds ) {
            await this.loadFeeds();
        }
    },
    methods: {
        async loadFeeds() {
            mApp.block( 'body', { message: this.$t( 'common.LoadingDataPleaseWait' ) } );

            let feeds = await clientapi.get( '/exportedfeeds' ).then( ( response ) => {
                return response.data;
            } );

            this.feedList = feeds;

            mApp.unblock( 'body' );
        },
        getViewLink( Identifier ) {
            return this.xml_url + Identifier;
        },
        submitForm() {
            if ( this.formData.feedId ) {
                this.editFeed();
            } else {
                this.addFeed();
            }
        },
        addFeed() {
            let name = this.formData.name;

            if ( name.length === 0 ) {
                return;
            }

            clientapi.post( '/exportedfeeds', { name: name } ).then( ( res ) => {
                if ( res.status === 200 ) {
                    swal( {
                        title: this.$t( 'Property.DataFeed.DataFeedCreated.title' ),
                        text: this.$t( 'Property.DataFeed.DataFeedCreated.text' ),
                        type: 'success',
                        confirmButtonClass: 'btn btn-brand m-btn m-btn--wide',
                        onBeforeOpen: () => {
                            onBeforeOpenSwal();
                        },
                    } );
                    this.loadFeeds();
                    $( '.modal' ).modal( 'hide' );
                } else {
                    let errorCode = res.data.code;
                    swal( {
                        title: this.$t( 'error.AnErrorOccurred' ),
                        text: this.$t( 'error.server.' + errorCode ),
                        type: 'error',
                        confirmButtonClass: 'btn btn-brand m-btn m-btn--wide',
                        onBeforeOpen: () => {
                            onBeforeOpenSwal();
                        },
                    } );
                }
            } );
        },
        editFeed() {
            let name = this.formData.name;

            if ( name.length === 0 ) {
                return;
            }

            let params = {
                Name: name,
                Active: true,
            };

            clientapi.put( '/exportedfeeds/' + this.formData.feedId, params ).then( ( res ) => {
                if ( res.status === 200 ) {
                    swal( {
                        title: this.$t( 'Property.DataFeed.DataFeedEdited.title' ),
                        text: this.$t( 'Property.DataFeed.DataFeedEdited.text' ),
                        type: 'success',
                        confirmButtonClass: 'btn btn-brand m-btn m-btn--wide',
                        onBeforeOpen: () => {
                            onBeforeOpenSwal();
                        },
                    } );
                    this.loadFeeds();
                    $( '.modal' ).modal( 'hide' );
                } else {
                    let errorCode = res.data.code;
                    swal( {
                        title: this.$t( 'error.AnErrorOccurred' ),
                        text: this.$t( 'error.server.' + errorCode ),
                        type: 'error',
                        confirmButtonClass: 'btn btn-brand m-btn m-btn--wide',
                        onBeforeOpen: () => {
                            onBeforeOpenSwal();
                        },
                    } );
                }
            } );
        },
        copyTextToClipboard( text ) {
            let vueThis = this;
            if ( navigator.clipboard ) {
                navigator.clipboard.writeText( text ).then( function() {
                    swal( {
                        title: vueThis.$t( 'Property.DataFeed.LinkCopied.title' ),
                        html: vueThis.$t( 'Property.DataFeed.LinkCopied.text' ),
                        showCancelButton: 0,
                        confirmButtonClass: 'btn btn-brand m-btn m-btn--custom',
                        confirmButtonText: vueThis.$t( 'common.okGotIt' ),
                        type: 'success',
                        onBeforeOpen: () => {
                            onBeforeOpenSwal();
                        },
                    } );
                } ).catch( function( err ) {
                    console.error( 'Fallback: Oops, unable to copy', err );
                    toastr.error( 'Could not copy text: ' + err );
                } );
            } else {
                let el = document.createElement( 'input' );
                el.setAttribute( 'style', 'position:absolute;top:-9999px' );
                el.value = text;
                document.body.appendChild( el );
                let range = document.createRange();
                el.contentEditable = 'true';
                el.readOnly = false;
                range.selectNodeContents( el );
                let s = window.getSelection();
                s.removeAllRanges();
                s.addRange( range );
                el.setSelectionRange( 0, 999999 );
                try {
                    document.execCommand( 'copy' );
                    swal( {
                        title: vueThis.$t( 'Property.DataFeed.LinkCopied.title' ),
                        html: vueThis.$t( 'Property.DataFeed.LinkCopied.text' ),
                        showCancelButton: 0,
                        confirmButtonClass: 'btn btn-brand m-btn m-btn--custom',
                        confirmButtonText: vueThis.$t( 'common.okGotIt' ),
                        type: 'success',
                        onBeforeOpen: () => {
                            onBeforeOpenSwal();
                        },
                    } );
                } catch ( err ) {
                    toastr.error( 'Could not copy text: ' + err );
                }

                el.remove();
            }
        },
        createDataFeed() {
            if ( this.feedList.length >= this.limitMaxFeed ) {
                swal( {
                    title: this.$t( 'Property.DataFeed.MaxFeedLimit.title' ),
                    text: this.$t( 'Property.DataFeed.MaxFeedLimit.text' ),
                    type: 'warning',
                    confirmButtonClass: 'btn btn-brand m-btn m-btn--wide',
                    onBeforeOpen: () => {
                        onBeforeOpenSwal();
                    },
                } );
                return;
            }

            this.formData.name = null;
            this.formData.feedId = null;
            this.modal_mode = 'create';
            $( '#addFeedModal' ).modal( 'show' );
        },
        editDataFeed( idFeed, name ) {
            this.formData.feedId = idFeed;
            this.formData.name = name;
            this.modal_mode = 'edit';
            $( '#addFeedModal' ).modal( 'show' );
        },
        async deleteDataFeed( idFeed, name ) {
            swal( {
                title: this.$t( 'Property.DataFeed.DataFeedDelete.title' ),
                text: this.$t( 'Property.DataFeed.DataFeedDelete.text', { name: name } ),
                showCancelButton: !0,
                confirmButtonClass: 'btn btn-brand m-btn m-btn--custom',
                confirmButtonText: this.$t( 'Property.DataFeed.DataFeedDelete.confirm' ),
                type: 'warning',
                onBeforeOpen: () => {
                    onBeforeOpenSwal();
                },
            } ).then( async ( isConfirm ) => {
                if ( !isConfirm.value ) {
                    return;
                }

                let res = await clientapi.put( '/exportedfeeds/' + idFeed, { Active: false } );
                if ( res.status === 200 ) {
                    swal( {
                        title: this.$t( 'Property.DataFeed.DataFeedDeleted.title' ),
                        text: this.$t( 'Property.DataFeed.DataFeedDeleted.text' ),
                        type: 'success',
                        confirmButtonClass: 'btn btn-brand m-btn m-btn--wide',
                        onBeforeOpen: () => {
                            onBeforeOpenSwal();
                        },
                    } );
                    this.loadFeeds();
                } else {
                    let errorCode = res.data.code;
                    swal( {
                        title: this.$t( 'error.AnErrorOccurred' ),
                        text: this.$t( 'error.server.' + errorCode ),
                        type: 'error',
                        confirmButtonClass: 'btn btn-brand m-btn m-btn--wide',
                        onBeforeOpen: () => {
                            onBeforeOpenSwal();
                        },
                    } );
                }
            } );
        },
    },
};
</script>

